"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignetSdk = void 0;
const react_1 = require("react");
const sdk_1 = require("../sdk");
const useSignetSdk = (option) => {
    const [inSignet, setInSignet] = (0, react_1.useState)();
    const sdkRef = (0, react_1.useRef)();
    const handleIsInSignet = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (typeof window === "undefined")
            return; // skip SSR
        const signetSdk = new sdk_1.SignetSdk(option);
        const isInSignet = yield signetSdk.init();
        setInSignet(isInSignet);
        if (isInSignet) {
            sdkRef.current = signetSdk;
        }
    }), [option]);
    (0, react_1.useEffect)(() => {
        handleIsInSignet();
    }, [handleIsInSignet]);
    return { sdk: sdkRef.current, inSignet };
};
exports.useSignetSdk = useSignetSdk;
